import { useCallback, useState } from 'react';
import { useConsoleStore } from '../store/consoleStore';

export function useCommandHistory() {
  const [inputValue, setInputValue] = useState('');

  const currentCommand = useConsoleStore((state) => state.currentCommand);
  const commandHistory = useConsoleStore((state) => state.commandHistory);
  const commandHistoryIndex = useConsoleStore((state) => state.commandHistoryIndex);
  const setCurrentCommand = useConsoleStore((state) => state.setCurrentCommand);
  const navigateHistory = useConsoleStore((state) => state.navigateHistory);
  const executeCommand = useConsoleStore((state) => state.executeCommand);
  const isExecuting = useConsoleStore((state) => state.isExecuting);

  const handleInputChange = useCallback((value: string) => {
    setInputValue(value);
    setCurrentCommand(value);
  }, [setCurrentCommand]);

  const handleKeyDown = useCallback((e: React.KeyboardEvent<HTMLInputElement | HTMLTextAreaElement>) => {
    switch (e.key) {
      case 'ArrowUp':
        e.preventDefault();
        navigateHistory('up');
        break;
      case 'ArrowDown':
        e.preventDefault();
        navigateHistory('down');
        break;
      case 'Enter':
        if (!e.shiftKey) {
          e.preventDefault();
          if (currentCommand.trim() && !isExecuting) {
            executeCommand(currentCommand);
            setInputValue('');
          }
        }
        break;
      case 'Escape':
        setInputValue('');
        setCurrentCommand('');
        break;
    }
  }, [navigateHistory, currentCommand, isExecuting, executeCommand, setCurrentCommand]);

  // Sync with store's current command (for history navigation)
  const displayValue = commandHistoryIndex >= 0 ? currentCommand : inputValue;

  return {
    value: displayValue,
    onChange: handleInputChange,
    onKeyDown: handleKeyDown,
    isExecuting,
    commandHistory,
  };
}
